import {
  config
} from '../_config'
import {
  authHeader,
  handleResponse
} from '../_helpers'

export const exposService = {
  getAll,
  createExpo,
  getOneById,
  updateExpo,
  getAmbit,
  getExpoType,
  addNewExpoDate,
  updateExpoDate,
  updateExpoBreeds,
  addNewExpoRateFilter,
  updateExpoRateFilter,
  deleteExpoRateFilter,
  addNewExpoComision,
  updateExpoComision,
  deleteExpoComision,
  addNewExpoClass,
  updateExpoClass,
  updateExpoClasses,
  deleteExpoClass,
  createExpoOtrosCp,
  updateExpoOtrosCp,
  delExpoOtrosCp,
  createExpoDescuentos,
  updateExpoDescuentos,
  delExpoDescuentos,
  createExpoDocsReq,
  updateExpoDocsReq,
  delExpoDocsReq,
  selectExpoDocTypesReq
}

function getAll() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

   return fetch(`${config.apiUrl}/expos`, requestOptions)
    .then(handleResponse)
/*
     const datos = fetch(`${config.apiUrl}/expos`, requestOptions)
    .then( function(response) {

      console.log("respuesta", response)

    })
    .catch(function (error) {
      console.log("error", error)
      return error
    });
    console.log( datos); */


}

function createExpo(data) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }
  return fetch(`${config.apiUrl}/expos`, requestOptions).then(handleResponse)
}

function getOneById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(`${config.apiUrl}/expos/${id}`, requestOptions).then(handleResponse)
}

function updateExpo(expo) {
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(expo)
  }

  return fetch(`${config.apiUrl}/expos/${expo.id}`, requestOptions).then(handleResponse)
}

function getAmbit() {

  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(`${config.apiUrl}/expoAmbits`, requestOptions)
    .then(handleResponse)
    .then(response => {
      localStorage.setItem('expo_ambits', JSON.stringify(response.data));
      return response
    })

}

function getExpoType() {

  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(`${config.apiUrl}/expoTypes`, requestOptions)
    .then(handleResponse)
    .then(response => {
      localStorage.setItem('expo_type', JSON.stringify(response.data));
      return response
    })

}

function addNewExpoDate(datos) {


  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoDates`, requestOptions).then(handleResponse)

}

function updateExpoDate(datos) {
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoDates/${datos.id}`, requestOptions).then(handleResponse)
}

function updateExpoBreeds(datos) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }
  return fetch(`${config.apiUrl}/expoBreeds`, requestOptions).then(handleResponse)
}

function addNewExpoRateFilter(datos) {

  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoRateFilter`, requestOptions).then(handleResponse)

}

function updateExpoRateFilter(datos) {

  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoRateFilter`, requestOptions).then(handleResponse)

}

function deleteExpoRateFilter(datos) {

  const requestOptions = {
    method: 'DELETE',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
  }

  return fetch(`${config.apiUrl}/expoRateFilter/${datos.id}`, requestOptions).then(handleResponse)

}

function addNewExpoComision(datos) {

  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoComisiones`, requestOptions).then(handleResponse)

}

function updateExpoComision(datos) {

  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoComisiones/${datos.id}`, requestOptions).then(handleResponse)

}

function deleteExpoComision(datos) {

  const requestOptions = {
    method: 'DELETE',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
  }

  return fetch(`${config.apiUrl}/expoComisiones/${datos.id}`, requestOptions).then(handleResponse)

}

/* FETCH PARA CLASES PERSONALIZADAS DE UNA EXPO */
function addNewExpoClass(datos) {

  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoDogClass`, requestOptions).then(handleResponse)

}

function updateExpoClass(datos) {

  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoDogClass/${datos.id}`, requestOptions).then(handleResponse)

}

function updateExpoClasses(datos) {

  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoDogClasses`, requestOptions).then(handleResponse)

}

function deleteExpoClass(datos) {

  const requestOptions = {
    method: 'DELETE',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
  }

  return fetch(`${config.apiUrl}/expoDogClass/${datos.id}`, requestOptions).then(handleResponse)

}

/* FETCH PARA LOS CONCEPTOS FACTURABLES DE UNA EXPO */
function createExpoOtrosCp(datos) {

  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoOtherConcepts`, requestOptions).then(handleResponse)

}

function updateExpoOtrosCp(datos) {

  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }
  return fetch(`${config.apiUrl}/expoOtherConcepts/${datos.id}`, requestOptions).then(handleResponse)

}

function delExpoOtrosCp(datos) {

  const requestOptions = {
    method: 'DELETE',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
  }
  return fetch(`${config.apiUrl}/expoOtherConcepts/${datos.id}`, requestOptions).then(handleResponse)

}

/* FETCH PARA LOS DESCUENTOS DE UNA EXPO */
function createExpoDescuentos(datos) {

  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoDiscounts`, requestOptions).then(handleResponse)

}

function updateExpoDescuentos(datos) {

  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }
  return fetch(`${config.apiUrl}/expoDiscounts/${datos.id}`, requestOptions).then(handleResponse)

}

function delExpoDescuentos(datos) {

  const requestOptions = {
    method: 'DELETE',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
  }
  return fetch(`${config.apiUrl}/expoDiscounts/${datos.id}`, requestOptions).then(handleResponse)

}

/* FETCH PARA LOS DOCUMENTOS REQUERIDOS DE UNA EXPO */
function createExpoDocsReq(datos) {

  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoDocsRequired`, requestOptions).then(handleResponse)

}

function updateExpoDocsReq(datos) {

  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }
  return fetch(`${config.apiUrl}/expoDocsRequired/${datos.id}`, requestOptions).then(handleResponse)

}

function delExpoDocsReq(datos) {

  const requestOptions = {
    method: 'DELETE',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
  }
  return fetch(`${config.apiUrl}/expoDocsRequired/${datos.id}`, requestOptions).then(handleResponse)

}

function selectExpoDocTypesReq(datos) {

  const requestOptions = {
    method: 'GET',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
  }
  return fetch(`${config.apiUrl}/expoDocTypesReq`, requestOptions).then(handleResponse)

}

